
const placeRadius = 25;
const transitionSize = 60;

export { placeRadius, transitionSize }; 